module.exports = __webpack_public_path__ + "img/play_s.5335de41.png";